import React from 'react'

export default function Door({ className, ...props }) {
  return (
    <svg className={`${className} w-8 h-8`} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.5 20V6C18.5 4.89543 17.6046 4 16.5 4H8.5C7.39543 4 6.5 4.89543 6.5 6V20M4.5 20H20.5" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.5 12H14.51" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
